module.exports = __webpack_public_path__ + "static/media/cmtl-logo.f3f06d28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cmtl-logo.png
// module id = 434
// module chunks = 0